import { defineStore } from 'pinia'
import { Payroll, Company, Country } from '@/app/core/services/payrolls'

export const usePayrollStore = defineStore('data-payroll', {
  persist: true,
  state: () => ({
    payroll: null as Payroll | null,
    company: null as Company | null,
    country: null as Country | null,
    allowedPayroll: [] as Payroll[],
    IRPF: [] as any
  }),

  actions: {
    changePayroll(payroll: Payroll) {
      this.payroll = payroll
      this.company = payroll.company
      this.country = payroll.country
    },
    setAllowedPayroll(payrolls: Payroll[]) {
      this.allowedPayroll = payrolls
      this.payroll = payrolls[0]
    },
    changeSelectedPayroll(payroll: Payroll) {
      this.payroll = payroll
    },

    changeSelectedPayrollByCode(code: string) {
      const payroll = this.allowedPayroll.find(p => p.code === code)
      if (payroll) {
        this.payroll = payroll
        window.location.reload()
      }
    }
  },
  getters: {
    menuPayroll(): Payroll[] {
      return this.allowedPayroll
    }
  }
})
